// src/domains/core/context-intelligence/hooks/useContextIntelligence.ts

import { useEffect, useCallback } from "react";

import { createIndicatorValueGetter } from "../engine/ruleEngine";
import { initializeIndicatorRegistry } from "../registry/indicatorRegistry";
import { initializeRelationshipRegistry } from "../registry/relationshipRegistry";
import { initializeRuleRegistry } from "../registry/ruleRegistry";
import { backgroundService } from "../services/backgroundService";

/**
 * Main hook for Context Intelligence Layer
 * Initializes the system and starts background processing
 *
 * @returns Object with isRunning flag
 *
 */
export function useContextIntelligence() {
  // Initialize registries on mount
  useEffect(() => {
    initializeIndicatorRegistry();
    initializeRelationshipRegistry();
    initializeRuleRegistry();
  }, []);

  // Get indicator values for all registered indicators
  // This is a simplified approach - in production, we'd need a better pattern
  const getHealthValue = useCallback((_indicatorId: string): null | number => {
    // NOTE: Placeholder implementation for PoC
    // Indicator values will be wired in Phase 2
    return null;
  }, []);

  const getProductivityValue = useCallback((_indicatorId: string): null | number => {
    // NOTE: Placeholder implementation for PoC
    return null;
  }, []);

  // Start background service
  useEffect(() => {
    const getIndicatorValue = createIndicatorValueGetter(getHealthValue, getProductivityValue);

    // Start background processing (5 minute interval)
    backgroundService.start(getIndicatorValue, 5 * 60 * 1000);

    return () => {
      backgroundService.stop();
    };
  }, [getHealthValue, getProductivityValue]);

  return {
    isRunning: backgroundService.running,
  };
}
